import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOSchema from '@/components/feature/SEOSchema';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedSites from './components/FeaturedSites';
import ArticlePreview from './components/ArticlePreview';

export default function Home() {
  return (
    <>
      <title>草莓导航 - 精选网站导航入口，一站直达优质资源</title>
      <meta name="description" content="草莓导航是一款精心整理的网站导航平台，汇聚海量优质网站资源，涵盖工具、娱乐、学习、购物等多个分类，让您快速找到所需网站，告别繁琐搜索，高效畅游互联网世界。" />
      <meta name="keywords" content="草莓导航,网站导航大全,优质网站推荐,网址导航,实用工具导航,学习资源导航,娱乐网站导航,精选网站入口" />
      <link rel="canonical" href="https://strawberry-nav.com" />

      <SEOSchema
        type="Organization"
        data={{
          name: '草莓导航',
          url: 'https://strawberry-nav.com',
          description: '精选网站导航入口，一站直达优质资源',
        }}
      />
      <SEOSchema
        type="WebSite"
        data={{
          name: '草莓导航',
          url: 'https://strawberry-nav.com',
          description: '精选网站导航入口，一站直达优质资源',
          inLanguage: 'zh-CN',
        }}
      />

      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedSites />
        <ArticlePreview />
      </main>

      <Footer />
    </>
  );
}